import { render } from "./propSelector.vue?vue&type=template&id=f003f4dc&ts=true"
import script from "./propSelector.vue?vue&type=script&lang=ts"
export * from "./propSelector.vue?vue&type=script&lang=ts"

import "./propSelector.vue?vue&type=style&index=0&id=f003f4dc&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__